import { AreaType } from './types.ts'

interface ZoneProps {
  area: AreaType
}

export default function Zone({ area }: ZoneProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nom :</strong>
        {area.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Communauté :</strong>
        {area.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {area.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Metadata:</strong>
        {area.metadata?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Statut :</strong>
        {area.status?.toString()}
      </p>
    </div>
  )
}
